module.exports = __webpack_public_path__ + "static/img/notice5.8c38ec1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notice5.png
// module id = 0Dfd
// module chunks = 2